import bg from "@/assets/enrollment-bg.jpg";
import { Outlet } from "react-router-dom";

const RegistrationLayout = () => {
  return (
    <div className="flex h-full overflow-hidden">
      <div className="hidden w-1/2 md:block">
        <img src={bg} alt="" className="block h-full w-full object-cover" />
      </div>
      <div className="w-full overflow-auto md:w-1/2">
        <Outlet />
      </div>
    </div>
  );
};

export default RegistrationLayout;
